var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRsMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4382_272010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.965 20.5068L9.3841 20.0088C8.58328 19.3383 1.59082 13.2993 1.59082 8.88199C1.59082 4.25707 5.34008 0.507812 9.965 0.507812C14.5899 0.507812 18.3392 4.25707 18.3392 8.88199C18.3392 13.2994 11.3467 19.3383 10.5492 20.0121L9.965 20.5068ZM9.965 2.31855C6.34184 2.32266 3.4057 5.25879 3.4016 8.88195C3.4016 11.657 7.70363 16.0902 9.965 18.1192C12.2264 16.0893 16.5284 11.6537 16.5284 8.88195C16.5243 5.25879 13.5882 2.3227 9.965 2.31855Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96496 12.2014C8.13168 12.2014 6.64551 10.7152 6.64551 8.88195C6.64551 7.04867 8.13168 5.5625 9.96496 5.5625C11.7982 5.5625 13.2844 7.04867 13.2844 8.88195C13.2844 10.7152 11.7983 12.2014 9.96496 12.2014ZM9.96496 7.22219C9.04832 7.22219 8.30523 7.96527 8.30523 8.88191C8.30523 9.79855 9.04832 10.5416 9.96496 10.5416C10.8816 10.5416 11.6247 9.79855 11.6247 8.88191C11.6247 7.96527 10.8816 7.22219 9.96496 7.22219Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4382_272010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsMarker);
export default __webpack_public_path__ + "static/media/fi-rs-marker.b755bc3c05f199e5b165cf24075ceca2.svg";
export { ForwardRef as ReactComponent };